export default __webpack_public_path__ + "static/media/pop_of_colour.1d839c47.jpg";